import { useTranslation } from 'react-i18next';

import { Cards, CardInfo, Image } from './styles';
import logoActive from '../../../img/ativo.svg';
import logoBrasil from '../../../img/country.svg';
import logoPaint from '../../../img/paint.svg';

export default function CardList({ iconButton, click }) {
  const { t } = useTranslation();

  const PointList = () => (
    <div className="points">
      <div />
      <div className="middlePoint" />
      <div />
    </div>
  );

  return (
    <Cards>
      <CardInfo onClick={() => click('technology')}>
        <div className="information">
          <Image>
            <img src={logoActive} alt="Tecnologia" width="50" height="50" />
          </Image>
          <div style={{ marginBottom: 30 }}>
            <header>{t('Alexandrite NdYAG')}</header>
            <div className="description">
              {t(
                'Exclusividade que une os melhores lasers do mundo e aplica em mais peles',
              )}
            </div>
          </div>
        </div>
        <div className="more-info">
          <button type="button" onClick={() => click('technology')}>
            {iconButton}
          </button>
        </div>
      </CardInfo>
      <PointList />
      <CardInfo onClick={() => click('genre')}>
        <div className="information">
          <Image>
            <img src={logoPaint} alt="Gênero" width="50" height="50" />
          </Image>
          <div style={{ marginBottom: 30 }}>
            <header>{t('Gênero não define preço')}</header>
            <div className="description">
              {t(
                'A primeira e única Rede de Depilação a Laser do Brasil sem distinção de preço por gênero',
              )}
            </div>
          </div>
        </div>
        <div className="more-info">
          <button type="button" onClick={() => click('genre')}>
            {iconButton}
          </button>
        </div>
      </CardInfo>
      <PointList />
      <CardInfo onClick={() => click('portability')}>
        <div className="information">
          <Image>
            <img src={logoBrasil} alt="Portabilidade" width="50" height="50" />
          </Image>
          <div style={{ marginBottom: 30 }}>
            <header>{t('Portabilidade_title')}</header>
            <div className="description">
              {t('a Vialaser, sem custos adicionais')}
            </div>
          </div>
        </div>
        <div className="more-info">
          <button type="button" onClick={() => click('portability')}>
            {iconButton}
          </button>
        </div>
      </CardInfo>
    </Cards>
  );
}
